module.exports = __webpack_public_path__ + "video-mute.svg?2546e5c75feda2419b15e88772889048";